import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ProjectHistoryList from "../ProjectHistory/ProjectHistoryList";


class WebPlatform extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);
        var filters = { industries: [], andTechs: false, techs: [], andSearch: false, search: ['Web'], };

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Web App Development Capabilities</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have developed web apps with the LAMP stack since about 1999.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have developed ASP (Classic) starting in 1999. I transitioned to ASP.Net in 2005</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>More recently I started Node.js and React.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <br/>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.title}>Here are some of my recent Web projects:</p>
                        <ProjectHistoryList filters={filters} displaycount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default WebPlatform



// WEBPACK FOOTER //
// src/Platforms/WebPlatform.js